import base from "@/store/utils/api-route/base";

const transaksiAPI = {
	customer: {
		info: `${base.meta}ringkasan_detail_transaksi_konsumen`,
		list: `${base.meta}list_transaksi_global`,
	},
	detail: `${base.meta}detail_data_transaksi`,
	detailLayanan: `${base.meta}get_detail_layanan_transaksi`,
	status: `${base.meta}list_status_transaksi_konsumen`,
	detail_pengantaran_extra: `${base.meta}detail_data_extra_pengantaran`,
	hapus: {
		transaksi: `${base.pembatalan}pembatalan_transaksi`,
		transaksiV2: `${base.pembatalan}pembatalan_transaksi_v2`,
		pengantaran_extra: `${base.pembatalan}penghapusan_antar_extra`,
	},
	permintaanHapus: `${base.pembatalan}setujui_permintaan_hapus_transaksi_v2`,
	export: {
		job: `${base.export}job`,
		track: `${base.export}track_redis_job`,
		delete: {
			cluster: `${base.export}delete_cluster_redis_job`,
			master: `${base.export}delete_master_redis_job`,
		},
	}
}

export default transaksiAPI